import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    // Save current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;
    console.log('🌍 [LanguageSwitcher] Before language change:');
    console.log('  - Current language:', i18n.language);
    console.log('  - Target language:', lng);
    console.log('  - Scroll position:', scrollPosition);
    
    // Change language
    i18n.changeLanguage(lng);
    console.log('🌍 [LanguageSwitcher] Language changed to:', lng);
    
    // Use multiple attempts to restore scroll position
    // The MagicTimelineSection animation resets scroll, so we need to be persistent
    const restoreScroll = () => {
      window.scrollTo(0, scrollPosition);
    };
    
    // Immediate restore
    requestAnimationFrame(restoreScroll);
    
    // Additional restores to override any animation resets
    setTimeout(restoreScroll, 50);
    setTimeout(restoreScroll, 100);
    setTimeout(restoreScroll, 200);
    setTimeout(restoreScroll, 300);
    
    // Final check
    setTimeout(() => {
      const finalScrollPosition = window.scrollY || window.pageYOffset;
      console.log('🌍 [LanguageSwitcher] After restore attempts:');
      console.log('  - Final scroll position:', finalScrollPosition);
      console.log('  - Expected:', scrollPosition);
      console.log('  - Success:', finalScrollPosition === scrollPosition);
      
      // One last restore if needed
      if (Math.abs(finalScrollPosition - scrollPosition) > 10) {
        console.log('  - Final correction needed, restoring...');
        window.scrollTo(0, scrollPosition);
      }
    }, 400);
  };

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="lang-separator">/</span>
      <button
        className={`lang-btn ${i18n.language === 'it' ? 'active' : ''}`}
        onClick={() => changeLanguage('it')}
        aria-label="Passa all'italiano"
      >
        IT
      </button>
    </div>
  );
};

export default LanguageSwitcher;
